import { useRef } from 'react';

export default function ReportChart({
    title,
    tooltipContent,
    switchToAltView,
    big = false,
    stack = false,
    children,
}) {
    const modalRef = useRef();

    function openModal() {
        modalRef.current.open = true;
    }

    function ExpandChartModal({ title, children }) {
        return (
            <gds-modal type="modal" ref={modalRef} className="report-chart-modal">
                <span slot="header">{title}</span>
                <span slot="descriptive-copy"></span>
                <div>
                    {children}
                </div>
            </gds-modal>
        )
    }

    return <>
        <div className={`chart ${big ? 'big' : ''} ${stack ? 'stack' : ''}`}>
            <div className="tooltip-label-container header">
                <div>{title}  {switchToAltView && <a href onClick={switchToAltView}> (switch view) </a>}</div>
                {tooltipContent && <gds-tooltip>{tooltipContent}</gds-tooltip>}
                <gds-icon type="button" icon-type="download-new-tab" size="small"
                    buttonarialabel="expand button" onClick={openModal} />
            </div>
            {children}
        </div>
        <ExpandChartModal title={title}>
            {children}
        </ExpandChartModal>
    </>;
};